import { DocumentReference } from '@firebase/firestore';
import { Dog, IDog, IProfile } from '@jumpstart/core';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import SendIcon from '@mui/icons-material/Send';
import Alert from '@mui/material/Alert';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { doc, getDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { db } from '../../../core/firebase';
import { useStateRef } from '../../../core/react/use-state-ref';
import { ISubscriber } from '../schemas';
import { sendMessage } from './services/Texting';

export interface IReplyAll {
  subscribers: ISubscriber[];

  onComplete(): void;

  onClose(): void;
}

export default function ReplyAll(props: IReplyAll) {
  const { subscribers, onComplete, onClose } = props;
  const [error, setError] = useState<null | Error>(null);
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);

  const [replies, setReplies, repliesRef] = useStateRef<any>({});


  const handleSubmit = async () => {
    console.log('Reply All...', body);
    if (sending) {
      return;
    }
    setSending(true);
    setError(null);
    for (const subscriber of subscribers) {
      // @TODO way to cancel this
      // if (!sending) {
      //   break;
      // }
      const profile: IProfile | null = await getDoc<IProfile>(doc(db, 'scout9-profiles', subscriber.uid) as DocumentReference<IProfile>)
        .then(doc => doc.exists() ? doc.data() : null);
      if (!profile) {
        console.error(`Missing profile from ${subscriber.phone}, ${subscriber.uid}`);
        setReplies({
          ...repliesRef.current,
          [subscriber.uid]: 'failed'
        });
        continue;
      }
      const dog: IDog | null = await getDoc<IDog>(doc(db, 'scout9-profiles', subscriber.uid, 'dogs', 'default') as DocumentReference<IDog>)
        .then(doc => doc.exists() ? doc.data() : null);
      if (!dog) {
        console.error(`Missing dog from ${subscriber.phone}, ${subscriber.uid}`);
        setReplies({
          ...repliesRef.current,
          [subscriber.uid]: 'failed'
        });
        continue;
      }
      const dogDaysOld = parseInt(Dog.ageFrom(dog.dob, 'days').toFixed(0), 10);
      await sendMessage(
        subscriber.uid,
        body,
        subscriber.phone,
        `DAY_${dogDaysOld}`,
        dogDaysOld
      )
        .then(() => {
          console.log('Succeeded sending to', subscriber.phone);
          setReplies({
            ...repliesRef.current,
            [subscriber.uid]: 'success'
          });
        })
        .catch((err: Error) => {
          console.error('Failed to send text message', subscriber.phone, err);
          setError(err);
          setReplies({
            ...repliesRef.current,
            [subscriber.uid]: 'failed'
          });
        });

    }
    setBody('');
    setReplies({});
    onComplete();
  };

  const handleCancel = () => {
    setError(null);
    setSending(false);
  };

  return (
    <Grid container direction="column" sx={{ padding: 6 }}>

      <DialogActions
        style={{ width: '100%', position: 'absolute' }}
      >
        <IconButton onClick={onClose}><CloseIcon/></IconButton>
      </DialogActions>

      <Typography variant="h5">Reply All</Typography>

      <List dense>
        {subscribers
          .filter((s: ISubscriber) => !s.end)
          .map((subscriber: ISubscriber) =>
            <ListItem key={`reply-all-${subscriber.uid}`}>
              <ListItemText
                primary={subscriber.phone}
                secondary={subscriber.email}
              />
              <ListItemSecondaryAction>
                {
                  repliesRef.current.hasOwnProperty(subscriber.uid)
                    ? (repliesRef.current[subscriber.uid] === 'success' ? <DoneIcon color="primary"/> :
                    <CloseIcon color="error"/>)
                    : null
                }
              </ListItemSecondaryAction>
            </ListItem>
          )}
      </List>

      {error ? <Alert severity="error">{error.message}</Alert> : null}

      <Paper
        sx={{
          padding: '2px 4px',
          display: 'flex',
          alignItems: 'center',
          width: '100%'
        }}
        elevation={0}>
        <InputBase
          sx={{
            marginLeft: 1,
            flex: 1
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setBody(event.target.value);
          }}
          placeholder="Message"
          multiline
          value={body}
        />
        <IconButton
          sx={{
            padding: 3
          }}
          aria-label="search"
          onClick={() => {
            if (sending) {
              handleCancel();
            } else {
              handleSubmit();
            }
          }}>
          {sending ? <CloseIcon color="error"/> : <SendIcon/>}
        </IconButton>
        {/*<Divider className={classes.divider} orientation="vertical" />*/}
        {/*<IconButton color="primary" className={classes.iconButton} aria-label="directions">*/}
        {/*  <DirectionsIcon />*/}
        {/*</IconButton>*/}
      </Paper>

    </Grid>
  );

}
